module.exports = __webpack_public_path__ + "img/bind_img.5f9b541c.png";